export default {
    delete_dashboard_title: "Borrar panel de control",
    delete_dashboard_descripcion: "¿Está seguro de que desea borrar este panel?",
    delete_dashboard_success_message: "Se ha eliminado el panel de control",
}